import { Link } from "react-router-dom";
// import { useCart } from "../context/CartContext";
// import { useToast } from "./ToastProvider";
import "./ProductCard.css";

export default function ProductCard({ product }) {
  // const { addItem } = useCart();
  // const { showToast } = useToast();

  // const handleAdd = (e) => {
  //   e.preventDefault();
  //   addItem(product);
  //   showToast(`«${product.name}» додано до кошика`, "success");
  // };

  const imageUrl = product.images[0]
    ? product.images[0].startsWith("http")
      ? product.images[0]
      : `${product.images[0]}`
    : null;

  return (
    <Link to={`/product/${product.id}`} className="product-card">
      <div className="product-card-image">
        {imageUrl ? (
          <img src={imageUrl} alt={product.name} loading="lazy" />
        ) : (
          <div className="product-card-placeholder">
            <svg viewBox="0 0 48 48" fill="none">
              <path
                d="M24 8C15.163 8 8 15.163 8 24s7.163 16 16 16 16-7.163 16-16S32.837 8 24 8z"
                fill="#e5cdb5"
              />
              <path
                d="M24 16c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 14c-4.42 0-8 1.79-8 4v1h16v-1c0-2.21-3.58-4-8-4z"
                fill="#c4855a"
                opacity=".5"
              />
            </svg>
          </div>
        )}
        {product.category && <span className="product-card-category">{product.category}</span>}
      </div>
      <div className="product-card-body">
        <h3 className="product-card-name">{product.name}</h3>
        {/* {product.description && <p className="product-card-desc">{product.description}</p>} */}
        <div className="product-card-footer">
          <span className="product-card-price">{Number(product.basePrice).toFixed(0)} ₴</span>
          {/* <button className="product-card-btn" onClick={handleAdd} aria-label="До кошика">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{ width: 15, height: 15 }}
            >
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10a4 4 0 01-8 0" />
            </svg>
          </button> */}
        </div>
      </div>
    </Link>
  );
}
